import { Injectable } from '@angular/core';
import { BaseHttpService, PageResponse } from '../auth/base-capacitor-http';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { BoxChartSeries } from '@swimlane/ngx-charts';

export class Product {
  id: string;
  upc: string;
  ref: string;
  source: string;
  brand: string;
  model: string;
  title: string;
  url: string;
  price: number;
  created: Date;
  latest: Date;
  variation: Variation;
}
export class Variation {
  color: string;
  size: string;
}

export class Pricing {
  id: string;
  ref: string;
  source: string;
  condition: string;
  highest: number;
  lowest: number;
  competitive: number;
  suggestedLowest: number;
  offers: number;
  created: number;
}

export class PricingSearchParams {
  page: number = 0;
  size: number = 10;
  range: Period = Period.DAY;
  sort: string;
  upc: string;
}
export enum Period{
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  ALL = 'ALL'
}

@Injectable({
  providedIn: 'root'
})
export class PriceMatcherService extends BaseHttpService {
  private baseURL: string = environment.server.mainURL;
  private URLEndPoint: string;

  constructor(client: HttpClient, snackBar: MatSnackBar) {
    super(client, snackBar);
  }

  async searchProduct(upc: string) {
    this.URLEndPoint = this.baseURL + 'product/' + upc;
    return this.get<Product>(this.URLEndPoint);

  }
  async getPrices(params: PricingSearchParams) {
    this.URLEndPoint = this.baseURL + 'pricing';
    return this.get<PageResponse<Pricing>>(this.URLEndPoint, params);
  }

  async getPricingHistory(params: PricingSearchParams) {
    this.URLEndPoint = this.baseURL + 'pricing-data';
    return this.get<Pricing[]>(this.URLEndPoint, params);
  }

  generateData(pricing: Pricing[]): BoxChartSeries[] {
   

    const chartData: BoxChartSeries[] = [
      {
        name: 'Highest',
        series: pricing.map(p => ({
          name: new Date(p.created * 1000).toDateString(),
          value: p.highest || 0,
        })),
      },
      {
        name: 'Lowest',
        series: pricing.map(p => ({
          name: new Date(p.created * 1000).toDateString(),
          value: p.lowest || 0,
        })),
      },
      {
        name: 'Competitive',
        series: pricing.map(p => ({
          name: new Date(p.created * 1000).toDateString(),
          value: p.competitive || 0,
        })),
      },
    ];

    return chartData;
  }

  getDummyProduct() {
    const product: Product = new Product();

    product.brand = 'Nike';
    product.model = 'Jordans'
    product.price = 15000;
    product.title = 'Nike Jordans';
    product.upc = '123456789';

    return product;
  }

  getDummyData(): BoxChartSeries[] {
    return [
      {
        "name": "Highest",
        "series": [
          {
            "value": 2451,
            "name": "2016-09-23T19:41:51.689Z"
          },
          {
            "value": 6934,
            "name": "2016-09-15T23:39:34.343Z"
          },
          {
            "value": 4347,
            "name": "2016-09-12T20:31:23.362Z"
          },
          {
            "value": 5537,
            "name": "2016-09-18T05:49:48.343Z"
          },
          {
            "value": 4894,
            "name": "2016-09-22T02:46:22.718Z"
          }
        ]
      },
      {
        "name": "Lowest",
        "series": [
          {
            "value": 4056,
            "name": "2016-09-23T19:41:51.689Z"
          },
          {
            "value": 5664,
            "name": "2016-09-15T23:39:34.343Z"
          },
          {
            "value": 6290,
            "name": "2016-09-12T20:31:23.362Z"
          },
          {
            "value": 6082,
            "name": "2016-09-18T05:49:48.343Z"
          },
          {
            "value": 3673,
            "name": "2016-09-22T02:46:22.718Z"
          }
        ]
      },
      {
        "name": "Competative",
        "series": [
          {
            "value": 6014,
            "name": "2016-09-23T19:41:51.689Z"
          },
          {
            "value": 5847,
            "name": "2016-09-15T23:39:34.343Z"
          },
          {
            "value": 6576,
            "name": "2016-09-12T20:31:23.362Z"
          },
          {
            "value": 4490,
            "name": "2016-09-18T05:49:48.343Z"
          },
          {
            "value": 4466,
            "name": "2016-09-22T02:46:22.718Z"
          }
        ]
      }
    ]
  }

}
